const TitleWithSampleText = {};

export default TitleWithSampleText